import React, { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useGetActualDataOutput } from '../../hooks/tanstack/useActualDataHook';
import { useGetRouteParams } from '../../hooks/tanstack/useUtilsHook';
import { type DataGridPremiumTableColumn } from '../DataGridPremiumTable';
import { FileDataTable } from '../dataset/IFSViewFilesDataTable';
import FormSelect from '../form/FormSelect';

const PINNED_COLUMNS = ['Aircraft', 'Base', 'Crew Rank', 'Driver'];

const ActualDataViewFilesTable = () => {
  const form = useForm();
  const { orgId, projectId } = useGetRouteParams();

  const { watch } = form;

  const template = watch('template') || '';

  const {
    data: actualDataOutput,
    isFetching: isFetchingData,
    isRefetching: isRefetchingData,
  } = useGetActualDataOutput({
    orgId,
    projectId,
  });

  const actualDataSchemaFiles = useMemo(
    () =>
      Object.keys(actualDataOutput ?? {}).map((templateName) => ({
        label: templateName,
        value: templateName,
      })),
    [actualDataOutput]
  );

  const columns = useMemo(
    () =>
      Object.keys(actualDataOutput?.[template] ?? {}).map((key) => ({
        name: key,
        label: key,
        is_pinned: PINNED_COLUMNS.includes(key),
        data_type: 'string',
        styles: [],
      })) as DataGridPremiumTableColumn[],
    [template, actualDataOutput]
  );

  const data = useMemo(
    () => actualDataOutput?.[template],
    [actualDataOutput, template]
  );

  return (
    <div className="space-y-4">
      <FormProvider {...form}>
        <form>
          <div className="flex max-w-[250px] gap-3">
            {actualDataSchemaFiles.length > 0 && (
              <FormSelect
                name="template"
                defaultValue={actualDataSchemaFiles[0]?.value}
                options={actualDataSchemaFiles.map((file) => ({
                  label: file.label,
                  value: file.value,
                }))}
                label="Template Name"
              />
            )}
          </div>
        </form>
      </FormProvider>
      <FileDataTable
        key={template}
        columns={columns}
        data={data || []}
        isLoading={isFetchingData || isRefetchingData}
      />
    </div>
  );
};

export default ActualDataViewFilesTable;
